import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import conversationApi from "@/services/modules/conversations";
import {
  SET_IS_FETCHING_CURRENT_CONVERSATION,
  SET_CURRENT_CONVERSATION,
  SET_MESSAGE_TEMPLATES,
  SET_IS_FETCHING_MESSAGE_TEMPLATES
} from "@/store/modules/conversations/mutations";
import { size, first } from "lodash";

export const FETCH_CONVERSATIONS = "FETCH_CONVERSATIONS";
export const FETCH_CURRENT_CONVERSATION = "FETCH_CURRENT_CONVERSATION";
export const FETCH_MESSAGE_TEMPLATES = "FETCH_MESSAGE_TEMPLATES";
export const CREATE_CONVERSATION = "CREATE_CONVERSATION";
export const CREATE_CONVERSATION_MESSAGE = "CREATE_CONVERSATION_MESSAGE";
export const ADD_CONVERSATION_MESSAGE_FILE = "ADD_CONVERSATION_MESSAGE_FILE";
export const EDIT_CONVERSATION = "EDIT_CONVERSATION";

const actions = {
  async [FETCH_CONVERSATIONS]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => conversationApi(commit).getConversations(params)
    });
  },
  async [FETCH_CURRENT_CONVERSATION]({ commit, dispatch }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => conversationApi(commit).getConversation(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CURRENT_CONVERSATION, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_CONVERSATION, data)
    });
  },
  async [FETCH_MESSAGE_TEMPLATES]({ commit, dispatch }, bookingIds) {
    let request;

    if (size(bookingIds) > 1) {
      const params = {
        filter: {
          booking_ids: bookingIds
        }
      };
      request = () => conversationApi(commit).getMessageTemplates(params);
    } else {
      request = () =>
        conversationApi(commit).getBookingMessageTemplates(first(bookingIds));
    }
    return handleWithErrorMessage({
      dispatch,
      request,
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_MESSAGE_TEMPLATES, isLoading),
      setDataFunction: ({ data }) => commit(SET_MESSAGE_TEMPLATES, data)
    });
  },
  async [CREATE_CONVERSATION]({ commit, dispatch }, data) {
    return handleWithErrorMessage({
      request: () => conversationApi(commit).createConversation(data),
      dispatch
    });
  },
  async [CREATE_CONVERSATION_MESSAGE]({ commit, dispatch }, data) {
    return handleWithErrorMessage({
      request: () => conversationApi(commit).createConversationMessage(data),
      dispatch
    });
  },
  async [EDIT_CONVERSATION]({ commit, dispatch }, { id, data }) {
    return handleWithGlobalMessage(
      () => conversationApi(commit).editConversation(id, data),
      dispatch
    );
  },
  async [ADD_CONVERSATION_MESSAGE_FILE]({ dispatch, commit }, { id, data }) {
    return handleWithErrorMessage({
      request: () =>
        conversationApi(commit).createConversationMessageFile(id, data),
      dispatch
    });
  }
};

export default actions;
